import React, { useState } from "react";
import { ExerciseTypeContainer } from "./ExerciseTypeContainer";

type DragAndDropProps = {
  item: {
    id: number;
    name: string;
  };
};

export const DragAndDrop: React.FC<DragAndDropProps> = ({ item }) => {
  const [draggedItem, setDraggedItem] = useState<string | null>(null);
  const [droppedItems, setDroppedItems] = useState<{ [key: string]: string }>({});

  // Example words to drag
  const dragWords = ["is", "am", "are", "was", "were"];
  
  // Example sentences with placeholders
  const sentences = [
    "I ____ a student.",
    "They ____ happy.",
    "She ____ at home yesterday."
  ];

  const handleDragStart = (word: string) => {
    setDraggedItem(word);
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>, sentenceIndex: number) => {
    e.preventDefault();
    if (draggedItem) {
      setDroppedItems({
        ...droppedItems,
        [sentenceIndex]: draggedItem
      });
      setDraggedItem(null);
    }
  };

  return (
    <ExerciseTypeContainer
      item={{ id: String(item.id), type: "drag_and_drop" }}
      title1="Arraste a palavra para completar a frase:"
      exerciseNumber={`exercicio n. ${item.id}`}
      hideVerifyButton
    >
      <div className="mt-4">
        <div className="flex flex-wrap gap-3 mb-6">
          {dragWords.map((word, index) => (
            <div
              key={index}
              draggable
              onDragStart={() => handleDragStart(word)}
              className="px-3 py-1 bg-blue-100 rounded-md shadow cursor-move hover:bg-blue-200 transition-colors"
            >
              {word}
            </div>
          ))}
        </div>
        
        <div className="space-y-4">
          {sentences.map((sentence, index) => {
            const [before, after] = sentence.split("____");
            return (
              <div key={index} className="flex items-center">
                <span>{before}</span>
                <div
                  onDragOver={handleDragOver}
                  onDrop={(e) => handleDrop(e, index)}
                  className={`inline-block mx-2 min-w-[60px] min-h-[30px] border-b-2 px-2 ${
                    droppedItems[index] ? "border-green-500" : "border-gray-400"
                  }`}
                >
                  {droppedItems[index]}
                </div>
                <span>{after}</span>
              </div>
            );
          })}
        </div>
      </div>
    </ExerciseTypeContainer>
  );
}; 